export enum FeatureFlagDictionaryEnum {
  ZIP_CODE_FLAG = 'ZipcodeEnabled',
  CVV_FLAG = 'CVVEnabled',
  ENABLE_RESOURCE_BUNDLE_MOCK = 'enable_resource_bundle_mock',
  DISPLAY_CONTEXTUAL_HELP_TRAVEL_DOCS = 'display-contextual-help-travel-docs',
  CRUISE_SURVEY = 'isNewToCruiseSurveyEnabled',
  MESSAGING_CENTER = 'isMessagingCenterEnabled',
  CRUISE_CONTRACT_COUNTRY_RESIDENCE = 'olci-ctc-source'
}